export enum Skills {
  CUE_TRAINING = 'cue-training',
  BEHAVIOR_MODIFICATION = 'behavior-modification',
  SOCIALIZATION = 'socialization',
  POTTY_TRAINING = 'potty-training',
  CRATE_TRAINING = 'crate-training',
  PUPPY_TRAINING = 'puppy-training',
  ADULT_DOG_TRAINING = 'adult-dog-training',
  CLICKER_TRAINING = 'clicker-training',
}

export enum Behaviors {
  BARKING = 'barking',
  BEGGING = 'begging',
  BITING_AND_CHEWING = 'biting-and-chewing',
  GUARDING_RESOURCES = 'guarding-resources',
  JUMPING = 'jumping',
  LEASH_MANNERS = 'leash-manners',
  SEPARATION_DISTRESS = 'separation-distress',
}

export enum BitingBehaviors {
  BITING_AND_CHEWING = 'biting-and-chewing',
  BITING = 'biting',
}

/**
 * Ideally, this would be stored in the db, but for the pilot, we're storing it here.
 * This must be kept in sync with training.constants.CURRENT_BEHAVIOR_CHOICES in the backend
 * (the source of truth for what is shown). training.constants.BEHAVIOR_CHOICES still exists
 * for slug→text translation of legacy values.
 *
 * (DEV-104195): Translate
 */
export const LABEL_FOR_BEHAVIOR: Record<Behaviors, string> = {
  [Behaviors.BARKING]: 'Barking',
  [Behaviors.BEGGING]: 'Begging',
  [Behaviors.BITING_AND_CHEWING]: 'Biting and chewing',
  [Behaviors.GUARDING_RESOURCES]: 'Guarding resources',
  [Behaviors.JUMPING]: 'Jumping',
  [Behaviors.LEASH_MANNERS]: 'Leash manners',
  [Behaviors.SEPARATION_DISTRESS]: 'Separation distress',
};

/**
 * Ideally, this would be stored in the db, but for the pilot, we're storing it here.
 * This must be kept in sync with training.constants.CURRENT_SKILL_CHOICES in the backend
 * (the source of truth for what is shown). training.constants.SKILL_CHOICES still exists
 * for slug→text translation of legacy values.
 *
 * (DEV-104195): Translate
 */
export const LABEL_FOR_SKILL: Record<Skills, string> = {
  [Skills.CUE_TRAINING]: 'Cue Training',
  [Skills.BEHAVIOR_MODIFICATION]: 'Behavior Modification',
  [Skills.SOCIALIZATION]: 'Socialization',
  [Skills.POTTY_TRAINING]: 'Potty Training',
  [Skills.CRATE_TRAINING]: 'Crate Training',
  [Skills.PUPPY_TRAINING]: 'Puppy Training',
  [Skills.ADULT_DOG_TRAINING]: 'Adult Dog Training',
  [Skills.CLICKER_TRAINING]: 'Clicker Training',
};
